export default __webpack_public_path__ + "static/media/both.2e0a1256.jpg";